/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["pixie-editor{display:block;width:100%;height:100%}pixie-editor .overlay{display:none}"];
export { styles as styles };
